<!-- Spinner de carga -->
<div *ngIf="loading" class="flex align-items-center justify-content-center m-0 p-0">
	<p-progressSpinner></p-progressSpinner>
  </div>
  
  <!-- Modal recortador de imagen -->
  <p-dialog
	header="Recortador de imagen"
	[style]="{ width: '70vw' }"
	[(visible)]="croppedActive"
	[modal]="true"
	[draggable]="false"
	[resizable]="false">
	<div class="croppe">
	  <image-cropper
		[imageChangedEvent]="imageChangedEvent"
		[maintainAspectRatio]="true"
		[aspectRatio]="1 / 1"
		resizeToHeight="512"
		format="jpeg"
		output="base64"
		(imageCropped)="imageCropped($event)"
		(imageLoaded)="imageLoaded($event)"
		(cropperReady)="cropperReady()"
		(loadImageFailed)="loadImageFailed()"
		class="cropper">
	  </image-cropper>
	</div>
  </p-dialog>
  
  <!-- Formulario de edición de perfil -->
  <div class="grid" *ngIf="!loading && user">
	<div class="col-12">
	  <div class="card" style="background: transparent">
		<form [formGroup]="form">
		  <!-- Campo oculto para user_id -->
		  <input type="hidden" formControlName="user_id" />
  
		  <!-- Sección para imagen -->
		  <div class="container-img">
			<div class="custom-file-upload" *ngIf="stringPhoto">
			  <img [src]="stringPhoto" style="width: 220px" alt="Foto cargada" />
			  <button type="button" pButton icon="pi pi-trash" class="ml-2" (click)="deletePhoto()" *ngIf="stringPhoto"></button>
			</div>
			<div class="custom-file-upload">
			  <input id="photoInputImage" type="file" (change)="handleUpload($event)" accept=".jpg,.png" />
			  <label class="btn-img">Selecciona imagen</label>
			</div>
		  </div>
  
		  <div class="grid p-fluid mt-3">
			<!-- Campo: Nombre (común a ambos roles) -->
			<div class="field col-12 md:col-4">
			  <label>Nombre *</label>
			  <input type="text" formControlName="name" pInputText class="w-full mb-3" />
			  <small class="p-error" *ngIf="form.get('name')?.touched && form.get('name')?.hasError('required')">
				Requerido
			  </small>
			  <small class="p-error" *ngIf="form.get('name')?.touched && form.get('name')?.hasError('pattern')">
				Introduzca solo letras
			  </small>
			</div>
  
			<!-- Campo: Email -->
			<div class="field col-12 md:col-4">
			  <label>Email *</label>
			  <input type="email" formControlName="email" pInputText class="w-full mb-3" autocomplete="off" />
			  <small class="p-error" *ngIf="form.get('email')?.touched && form.get('email')?.hasError('required')">
				Requerido
			  </small>
			  <small class="p-error" *ngIf="form.get('email')?.touched && form.get('email')?.hasError('email')">
				Formato incorrecto
			  </small>
			</div>
  
			<!-- Campo: Teléfono -->
			<div class="field col-12 md:col-4">
			  <label>Teléfono *</label>
			  <input type="text" formControlName="phone" pInputText class="w-full mb-3" maxlength="20" placeholder="+00 9999..." />
			  <small class="p-error" *ngIf="form.get('phone')?.touched && form.get('phone')?.hasError('required')">
				Requerido
			  </small>
			  <small class="p-error" *ngIf="form.get('phone')?.touched && form.get('phone')?.hasError('pattern')">
				Introduzca valores numéricos
			  </small>
			</div>
  
			<!-- Campos de contraseña (sólo si se desea actualizar) -->
			<div class="field col-12 md:col-4">
			  <label>Contraseña</label>
			  <p-password formControlName="password" [toggleMask]="true" autocomplete="new-password"></p-password>
			</div>
			<div class="field col-12 md:col-4">
			  <label>Confirmación de contraseña</label>
			  <p-password formControlName="password_confirmation" [toggleMask]="true" autocomplete="new-password"></p-password>
			  <small class="p-error" *ngIf="form.get('password_confirmation')?.touched && form.get('password_confirmation')?.hasError('required')">
				Requerido
			  </small>
			  <small class="p-error" *ngIf="form.get('password_confirmation')?.touched && form.get('password_confirmation')?.errors">
				Contraseña y confirmación no coinciden
			  </small>
			</div>
		  </div>
  
		  <div class="flex justify-content-end col-12">
			<p-button styleClass="p-button-primary p-button-rounded" label="Actualizar datos" (click)="(user.role_id === 1) ? handleConfirmUpdate() : saveUser()"></p-button>
		  </div>
		</form>
	  </div>
	</div>
  </div>
  
  <!-- Modal para confirmar actualización (ejemplo para administradores) -->
  <p-dialog header="Actualización de datos de usuario" [(visible)]="confirmUpdateDialog" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '30vw' }">
	<div class="grid p-fluid mt-3">
	  <div class="form-container">
		<div class="field col-12" *ngIf="user">
		  Está intentando actualizar sus datos de usuario administrador por los siguientes:
		  <ol>
			<li><strong>Email: </strong>{{ newEmail }}</li>
			<li><strong>Nombre: </strong>{{ newName }}</li>
		  </ol>
		</div>
	  </div>
	</div>
	<ng-template pTemplate="footer">
	  <p-button styleClass="p-button-rounded mt-4" label="Confirmar datos" (click)="saveUser()" [loading]="loading"></p-button>
	</ng-template>
  </p-dialog>
  